function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Upload from './Upload';

var Dragger = function Dragger(props) {
  return React.createElement(Upload, _extends({}, props, {
    type: "drag",
    style: _extends(_extends({}, props.style), {
      height: props.height
    })
  }));
};

export default Dragger;
//# sourceMappingURL=Dragger.js.map
